import { customAlertState } from "@mirage/components/snackbar/CustomSnackbar";
import { AlertColor } from "@mui/material";
import { useCallback } from "react";
import { useSetRecoilState } from "recoil";

export type ShowAlert = (message: string, severity: AlertColor, duration?: number) => void;

const useAlertService = () => {
    const setAlertState = useSetRecoilState(customAlertState);
    const showAlert: ShowAlert = useCallback((message: string, severity: AlertColor, duration?: number) => {
        setAlertState(() => {
            return {
                isOpen: true,
                message: message,
                severity: severity,
                duration: duration,
            };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return showAlert;
};

export default useAlertService;
